/*
 * COPYRIGHT (c) 2024
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import React from 'react';
import { useTranslation } from '@scuf/localization';
import { DataContextProvider } from '@forge/data-connector';

import descriptors from '../../locales/en-US/descriptors';

import './BaselineConfigTheme.scss';
import IEnergyManagementProps, {
  IRequestContext
} from '../DashboardKPIWidgets/IEnergyManagementProps';
import { ContextProvider, updateApiConfig } from '../../context/ApiContext';
import UtilityBillBaselineSettings from './UtilityBillBaseline/UtilityBillBaselineSettings';
import { withLocalization } from '../../locales/withLocalization';

interface IBaselineConfigSettingsProps {
  requestContext: IRequestContext;
}

const BaselineConfigSettingsComponent: React.FC<IBaselineConfigSettingsProps> = (
  props: IBaselineConfigSettingsProps
) => {
  const { requestContext } = props;

  const baselineConfigDesc = descriptors.baseline;
  const [t] = useTranslation();

  return (
    <div className="baseline-config-settings-wrapper">
      <div className="baseline-config-settings-header">
        <div className="baseline-config-settings-header-title">
          {t(baselineConfigDesc.baselineconfiguration)}
        </div>
        <div className="baseline-config-settings-header-description">
          {t(baselineConfigDesc.baselineConfigDesc)}
        </div>
      </div>
      <div className="baseline-config-settings-content">
        <UtilityBillBaselineSettings requestContext={requestContext} />
      </div>
    </div>
  );
};

const BaselineConfigSettingsWidget = (props: IEnergyManagementProps) => {
  const { connectorConfig, emaasContext, requestContext } = props;

  return (
    <ContextProvider
      value={updateApiConfig({
        connectorConfig,
        ...emaasContext
      })}
    >
      <DataContextProvider config={connectorConfig}>
        <BaselineConfigSettingsComponent requestContext={requestContext} />
      </DataContextProvider>
    </ContextProvider>
  );
};

export default withLocalization<IEnergyManagementProps>(
  BaselineConfigSettingsWidget
);
